module.exports = __webpack_public_path__ + "static/media/Anna Silveira Logo.bafc641d.jpeg";